<div class="commande head">
    <div class="container">
        <div class="card-header">
            <ul class="nav" [class.pl-25]="isAuthenticated" [class.pl-18]="!isAuthenticated">
                <li class="nav-item deco" [ngClass]="{on:activestep>=1}" (click)="goTostep(1)">
                    <span class="title"></span>
                    <span  [class.onTitle]="activestep>=1">RÉCAPITULATIF</span>
                    <span class="ln" [class.onLn]="activestep>=2"></span>
                    <!-- <span class="deco"></span> -->
                </li>
                <li class="nav-item deco" [ngClass]="{on:activestep>=2}" (click)="goTostep(2)" *ngIf="!isAuthenticated">
                    <span class="title"></span>
                    <span [class.onTitle]="activestep>=2">CONNEXION</span>
                    <span class="ln" [class.onLn]="activestep>=3"></span>
                    <!-- <span class="deco"></span> -->
                </li>
                <li class="nav-item deco" [ngClass]="{on:activestep==3}" (click)="goTostep(3)">
                    <span class="title"></span>
                    <span [class.onTitle]="activestep>=3">CONFIRMATION</span>
                </li>
            </ul>
        </div>
        <summary *ngIf="activestep==1" (onNext)="next()"></summary>
        <div class="signin">
            <checkout-authentification *ngIf="activestep==2" (onNext)="next()"></checkout-authentification>
        </div>
        <confirmation *ngIf="activestep==3"></confirmation>
    </div>
</div>